<template>
  <vxe-grid ref="rankTable" v-bind="vxeOption"> </vxe-grid>
</template>

<script>
import {
  rankTableOptionColums,
  tableOption,
} from "@/views/report/indicators/option/tableOption.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      vxeOption: {},
    };
  },
  computed: {
    ...mapGetters(["rankTableData"]),
  },
  watch: {
    rankTableData: {
      deep: true,
      handler(newVal, oldVal) {
        this.getTableData();
      },
    },
  },
  methods: {
    getTableData() {
      this.$refs.rankTable.reloadData(this.rankTableData.records);
    }
  },
  created() {
    Object.assign(this.vxeOption, tableOption);
    this.vxeOption.columns = rankTableOptionColums;
  },

  mounted() {
  },
};
</script>

<style lang="scss">
</style>
